const INITIAL_STATE = {
  data: [],
  isFetching: false,
  addSuccess: false,
  addError: false,
  editSuccess: false,
  editError: false,
  removeSuccess: false,
  removeError: false,
  getAllError: false,
  errorContent: '',
  groupConfigSuccess: false,
  groupConfigError: false,
  groupSyncSuccess: false,
  groupSyncError: false
};

const reducer = (state = INITIAL_STATE, action) => {
  const { type, payload } = action;
  switch (type) {
    case 'DEVICES_START_REQUEST':
      return {
        ...state,
        isFetching: true,
        addError: false,
        editError: false,
        errorContent: ''
      };
    case 'DEVICES_END_REQUEST':
      return {
        ...state,
        addSuccess: false,
        editSuccess: false,
        removeSuccess: false,
        isFetching: false,
        groupConfigSuccess: false,
        groupConfigError: false
      };
    case 'DEVICES_GET_ALL_SUCCESS':
      return {
        ...state,
        data: payload
      };
    case 'DEVICES_GET_ALL_ERROR':
      return {
        ...state,
        getAllError: true,
        errorContent: payload
      };
    case 'DEVICES_ADD_SUCCESS':
      return {
        ...state,
        data: state.data.concat(payload),
        addSuccess: true,
        addError: false
      };
    case 'DEVICES_ADD_ERROR':
      return {
        ...state,
        addSuccess: false,
        addError: true,
        errorContent: payload
      };
    case 'DEVICES_EDIT_SUCCESS':
      return {
        ...state,
        data: state.data.map(item =>
          item._id !== payload._id ? { ...item } : { ...payload }
        ),
        editSuccess: true,
        editError: false
      };
    case 'DEVICES_EDIT_ERROR':
      return {
        ...state,
        editSuccess: false,
        editError: true,
        errorContent: payload
      };
    case 'DEVICES_REMOVE_SUCCESS':
      return {
        ...state,
        removeSuccess: true,
        removeError: false,
        data: state.data.map(item =>
          item._id !== payload ? { ...item } : { ...item, active: false }
        )
      };
    case 'DEVICES_REMOVE_ERROR':
      return {
        ...state,
        removeSuccess: false,
        removeError: true,
        errorContent: payload
      };
    case 'DEVICES_GROUP_CONFIG_SUCCESS':
      return {
        ...state,
        groupConfigSuccess: true,
        groupConfigError: false
      };
    case 'DEVICES_GROUP_CONFIG_ERROR':
      return {
        ...state,
        groupConfigSuccess: false,
        groupConfigError: true,
        errorContent: payload
      };
    case 'DEVICES_GROUP_SYNC_SUCCESS':
      return {
        ...state,
        groupSyncSuccess: true,
        groupSyncError: false
      };
    case 'DEVICES_GROUP_SYNC_ERROR':
      return {
        ...state,
        groupSyncSuccess: false,
        groupSyncError: true
      };
    case 'DEVICES_UPDATE_ITEM_STORE':
      return {
        ...state,
        data: state.data.map(item =>
          item._id === payload._id ? { ...item, ...payload } : item
        )
      };
    case 'DEVICES_MODIFY_STORE': {
      const ids = payload.map(item => item._id);
      const items = state.data.filter(item => !ids.includes(item._id));
      return {
        ...state,
        data: items.concat(payload)
      };
    }
    default:
      return { ...state };
  }
};

export default reducer;
